module.exports = __webpack_public_path__ + "img/fastspin.dd5b0724.png";